export const PATH_TO_FORMS = '/contact/nous-contacter?q=';

export const SUBJECT_FIELD_NAME = 'ffr-subject';

export const FILE_INPUT_1 = 'ffr-contact_file';
export const FILE_INPUT_2 = 'ffr-contact_file-2';
export const FILE_FORMAT_ERROR_MESSAGE = 'Le format du fichier est incorrect.';

// ! @todo => à compléter par les formulaires des comités et des clubs
export const FORMS_WITH_FIELD_CONTAINER_DIV_INPUT_ONLY = ['formulaire-de-contact-1-2', 'emploi_candidature_spontannee'];
